module.exports = __webpack_public_path__ + "static/img/a2.c6b354d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safe/a2.png
// module id = xRhJ
// module chunks = 1